import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { ObjectNames,Status,  Severity, Answer } from '../../constants/constants';
import { FieldsService } from '../../product/fields/fields.service';
import { PurchaseService } from '../../purchase/purchase.service';
import data from '../../staticJSON/fieldData.json';

@Component({
  selector: 'app-purchase-fields',
  templateUrl: './purchase-fields.component.html',
  styleUrls: ['./purchase-fields.component.scss']
})
export class PurchaseFieldsComponent implements OnInit {

  vendorTypeGroup: any;
  businessTypeGroup: any;
  vendorTypes = [];
  businessTypes = [];
  employeesCounts = [];
  revenue = [];
  industries = [];
  ownerships = [];
  purchaseAddEditFieldForm: FormGroup;
  purchaseAddEditAccountFieldForm: FormGroup;
  showPurchaseFieldVendorForm = false;
  displayAddEditAccountData = false;
  addEditPurchaseFieldHeader: string = '';
  selectedAccountType: string = '';
  purchaseFieldDataTypes = data.purchaseFieldType;
  fieldDataConstants = ObjectNames.purchaseOrderConstants;
  invalidData = false;

  constructor(private configService: ConfigurationService,
    private fieldService: FieldsService,
    private fb: FormBuilder,
    private app: AppMainComponent,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private titlecasePipe: TitleCasePipe,
    private purchaseConfigService: PurchaseService) { }

  ngOnInit(): void {
    this.purchaseConfigService.getPurchaseField().subscribe(field => {
      if (field) {
        this.openPurchaseFieldVendorAddPopup();
      }
    })

    this.purchaseAddEditFieldForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      updatedBy: [this.app.companyId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      name: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      parentTypeId: [0],
      description: [''],
      groupId: [null],
      organizationId: [null],
      colorCodeId: [0],
      statusId: [Status.ACTIVE],
      fieldType:  [{value: '', disabled: true}],
      // group: [''], // status: [''],
    });
    
    this.configService.getInventoryGroupList().subscribe(groups => {
      this.vendorTypeGroup = groups.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Field_Name)[0];
      this.businessTypeGroup = groups.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name)[0];
      this.getPurchaseVendors(this.vendorTypeGroup?.id);
      this.getPurchaseBusinessClassification(this.businessTypeGroup?.id);
    });
    this.getAllEmployees();    
    this.getAllRevenue();   
    this.getAllIndustries(); 
    this.getAllOwnerships();
  }

  getAllEmployees() {
    this.configService.getAllEmployeesCount().then(count => {
      this.employeesCounts = count;
    });
  }

  getAllRevenue() {
    this.configService.getAllRevenue().then(revenue => {
      this.revenue = revenue;
    });
  }

  getAllIndustries() {
    this.configService.getAllIndustries().then(industries => {
      this.industries = industries;
    });
  } 
  
  getAllOwnerships() {
    this.configService.getAllOwnerships().then(ownerships => {
      this.ownerships = ownerships;
    });
  }

  getPurchaseVendors(groupId){
    this.fieldService.getWarrantyList(groupId).subscribe(vendors => {
      this.vendorTypes = vendors;
    });
  }

  getPurchaseBusinessClassification(groupId){
    this.fieldService.getWarrantyList(groupId).subscribe(business => {
      this.businessTypes = business;
    });
  }

  openPurchaseFieldVendorPopup(vendorRowData, selectedType) {
    this.addEditPurchaseFieldHeader = ObjectNames.purchaseOrderConstants.Purchase_Field_Edit_Title;
    this.selectedAccountType = selectedType; 
    this.purchaseAddEditFieldForm.patchValue(vendorRowData);
    this.purchaseAddEditFieldForm.get('fieldType').setValidators(null);
    this.purchaseAddEditFieldForm.get('fieldType').updateValueAndValidity({emitEvent:false});
    this.showPurchaseFieldVendorForm = true;
  }

  updatePurchaseFieldsData() {
    if (this.addEditPurchaseFieldHeader == ObjectNames.purchaseOrderConstants.Purchase_Field_Edit_Title) { // Edit
      if(this.selectedAccountType ==  ObjectNames.purchaseOrderConstants.Purchase_Field_Name || this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name) {
        if(this.selectedAccountType ==  ObjectNames.purchaseOrderConstants.Purchase_Field_Name) {
          this.invalidData = this.vendorTypes.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase() && data?.id !== this.purchaseAddEditFieldForm?.value?.id)? true: false;
        } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name) {
          this.invalidData = this.businessTypes?.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase() && data?.id !== this.purchaseAddEditFieldForm?.value?.id)? true: false;
        }
        if(this.invalidData) return;
        this.fieldService.updateWarrantyList(this.purchaseAddEditFieldForm.value).then(res => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Updated Successfully...' });
          if (this.vendorTypeGroup?.id == this.purchaseAddEditFieldForm.value.groupId) {
            this.getPurchaseVendors(this.purchaseAddEditFieldForm.value.groupId); // this.vendorTypeGroup.id
          } else if (this.businessTypeGroup?.id == this.purchaseAddEditFieldForm.value.groupId) {
            this.getPurchaseBusinessClassification(this.purchaseAddEditFieldForm.value.groupId); // this.vendorTypeGroup.id
          }
          this.showPurchaseFieldVendorForm = false;
        });
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Number_Of_Employee_Field_Name) {
        this.invalidData = this.employeesCounts.find(employeeData => employeeData?.name?.toLowerCase() == this.purchaseAddEditFieldForm.value.name.toLowerCase() && employeeData?.id !== this.purchaseAddEditFieldForm.value.id)? true: false;
        if(this.invalidData) return;
        this.configService.EditEmployeesNo(this.purchaseAddEditFieldForm.value).then(employeeData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
          this.getAllEmployees();    
          this.showPurchaseFieldVendorForm = false;
        });
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Estimated_Revenue_Field_Name) {
        this.invalidData = this.revenue.find(revenueData => revenueData?.name?.toLowerCase() == this.purchaseAddEditFieldForm.value.name.toLowerCase() && revenueData?.id !== this.purchaseAddEditFieldForm.value.id)? true: false;
        if(this.invalidData) return;
        this.configService.EditRevenue(this.purchaseAddEditFieldForm.value).then(employeeData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
          this.getAllRevenue();    
          this.showPurchaseFieldVendorForm = false;
        });
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Industry_Field_Name) {
        this.invalidData = this.industries.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm.value.name.toLowerCase() && data?.id !== this.purchaseAddEditFieldForm.value.id)? true: false;
        if(this.invalidData) return;
        this.configService.EditIndustry(this.purchaseAddEditFieldForm.value).then(employeeData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
          this.getAllIndustries();    
          this.showPurchaseFieldVendorForm = false;
        });
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Ownership_Type_Field_Name) {
        this.invalidData = this.ownerships.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm.value.name.toLowerCase() && data?.id !== this.purchaseAddEditFieldForm.value.id)? true: false;
        if(this.invalidData) return;
        this.configService.EditOwnership(this.purchaseAddEditFieldForm.value).then(employeeData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
          this.getAllOwnerships();    
          this.showPurchaseFieldVendorForm = false;
        });
      }
    } else if (this.addEditPurchaseFieldHeader == ObjectNames.purchaseOrderConstants.Purchase_Field_Add_Title) { // Add
      if(this.selectedAccountType ==  ObjectNames.purchaseOrderConstants.Purchase_Field_Name || this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name) {
        if(this.selectedAccountType ==  ObjectNames.purchaseOrderConstants.Purchase_Field_Name) {
          this.invalidData = this.vendorTypes?.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase())? true: false;
        } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name) {
          this.invalidData = this.businessTypes?.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase())? true: false;
        }
        if(this.invalidData) return;
        this.fieldService.addWarrantyList(this.purchaseAddEditFieldForm.value).then(res => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Added Successfully...' });
          // this.getPurchaseVendors(this.purchaseAddEditFieldForm.value.groupId); // this.vendorTypeGroup.id
          if(this.vendorTypeGroup?.id == this.purchaseAddEditFieldForm.value.groupId) {
            this.getPurchaseVendors(this.purchaseAddEditFieldForm.value.groupId); // this.vendorTypeGroup.id
          } else if (this.businessTypeGroup?.id == this.purchaseAddEditFieldForm.value.groupId) {
            this.getPurchaseBusinessClassification(this.purchaseAddEditFieldForm.value.groupId); // this.vendorTypeGroup.id
          }
          this.showPurchaseFieldVendorForm = false;
        });
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Number_Of_Employee_Field_Name) {
        this.invalidData = this.employeesCounts.find(employeeData => employeeData?.name?.toLowerCase() == this.purchaseAddEditFieldForm.value.name.toLowerCase())? true: false;
        if(this.invalidData) return;
        this.configService.addEmployeesNo(this.purchaseAddEditFieldForm.value).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
          this.getAllEmployees();    
          this.showPurchaseFieldVendorForm = false;
        })
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Estimated_Revenue_Field_Name) {
        this.invalidData = this.revenue.find(revenueData => revenueData?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase())? true: false;
        if(this.invalidData) return;
        this.configService.addRevenue(this.purchaseAddEditFieldForm.value).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
          this.getAllRevenue();    
          this.showPurchaseFieldVendorForm = false;
        })
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Industry_Field_Name) {
        this.invalidData = this.industries.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase())? true: false;
        if(this.invalidData) return;
        this.configService.addIndustry(this.purchaseAddEditFieldForm.value).then(employeeData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
          this.getAllIndustries();    
          this.showPurchaseFieldVendorForm = false;
        });
      } else if (this.selectedAccountType == ObjectNames.purchaseOrderConstants.Purchase_Ownership_Type_Field_Name) {
        this.invalidData = this.ownerships.find(data => data?.name?.toLowerCase() == this.purchaseAddEditFieldForm?.value?.name?.toLowerCase())? true: false;
        if(this.invalidData) return;
        this.configService.addOwnership(this.purchaseAddEditFieldForm.value).then(employeeData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
          this.getAllOwnerships();    
          this.showPurchaseFieldVendorForm = false;
        });
      }      
    }
  }

  openPurchaseFieldVendorAddPopup() {
    this.purchaseAddEditFieldForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      updatedBy: [this.app.companyId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      name: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      parentTypeId: [0],
      description: [''],
      groupId: [],
      organizationId: [this.app.companyId],
      colorCodeId: [0],
      statusId: [Status.ACTIVE],
      fieldType: ['', [Validators.required]]
    });
    this.purchaseAddEditFieldForm.get('fieldType').valueChanges.subscribe(data => {
      if (!data) return;
      if(ObjectNames.purchaseOrderConstants.Purchase_Field_Name.toLowerCase() == data?.name?.toLowerCase()) {
        this.purchaseAddEditFieldForm.get('groupId').setValue(this.vendorTypeGroup?.id);
        this.selectedAccountType = ObjectNames.purchaseOrderConstants.Purchase_Field_Name;
      } else if (ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name.toLowerCase()== data?.name?.toLowerCase()) {
        // this.businessTypeGroup?.id // 'business classification' ==
        this.purchaseAddEditFieldForm.get('groupId').setValue(this.businessTypeGroup?.id);
        this.selectedAccountType = ObjectNames.purchaseOrderConstants.Purchase_Business_Field_Name;
      } else if (data?.name?.toLowerCase() == ObjectNames.purchaseOrderConstants.Purchase_Number_Of_Employee_Field_Name.toLowerCase()) {
        this.selectedAccountType = ObjectNames.purchaseOrderConstants.Purchase_Number_Of_Employee_Field_Name;
      } else if (data?.name?.toLowerCase() == ObjectNames.purchaseOrderConstants.Purchase_Estimated_Revenue_Field_Name.toLowerCase()) {
        this.selectedAccountType = ObjectNames.purchaseOrderConstants.Purchase_Estimated_Revenue_Field_Name;
      } else if (data?.name?.toLowerCase() == ObjectNames.purchaseOrderConstants.Purchase_Industry_Field_Name.toLowerCase()) {
        this.selectedAccountType = ObjectNames.purchaseOrderConstants.Purchase_Industry_Field_Name;
      } else if (data?.name?.toLowerCase() == ObjectNames.purchaseOrderConstants.Purchase_Ownership_Type_Field_Name.toLowerCase()) {
        this.selectedAccountType = ObjectNames.purchaseOrderConstants.Purchase_Ownership_Type_Field_Name;
      }
    });
    this.showPurchaseFieldVendorForm = true;
    this.addEditPurchaseFieldHeader = ObjectNames.purchaseOrderConstants.Purchase_Field_Add_Title;
    this.invalidData = false;
  }

  delete(data, type, index) {
    this.confirmationService.confirm({
      message: `Do you want to delete this ${type}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteFieldData(data, type, index);
      },
      reject: () => {
      }
    });
  }

  deleteFieldData(fieldData, type, index) {
    if (this.vendorTypeGroup?.id == fieldData?.groupId || this.businessTypeGroup?.id == fieldData?.groupId) {
      this.fieldService.deleteWarrantyList(fieldData.id).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
        if (this.vendorTypeGroup?.id == fieldData?.groupId) {
          this.vendorTypes.splice(index, 1);
        } else if (this.businessTypeGroup?.id == fieldData?.groupId) {
          this.businessTypes.splice(index, 1);
        }
      }).catch(() => {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
      });
    } else if (type == ObjectNames.purchaseOrderConstants.Purchase_Number_Of_Employee_Field_Name) {
      this.configService.deleteEmployeesNo(fieldData?.id).then(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
        this.employeesCounts.splice(index, 1);
      }).catch(() => {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
      });
    } else if (type == ObjectNames.purchaseOrderConstants.Purchase_Estimated_Revenue_Field_Name) {
      this.configService.deleteRevenue(fieldData?.id).then(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
        this.revenue.splice(index, 1);
      }).catch(() => {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
      });
    } else if (type == ObjectNames.purchaseOrderConstants.Purchase_Industry_Field_Name) {
      this.configService.deleteIndustry(fieldData?.id).then(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
        this.industries.splice(index, 1);
      }).catch(() => {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
      });
    }  else if (type == ObjectNames.purchaseOrderConstants.Purchase_Ownership_Type_Field_Name) {
      this.configService.deleteOwnership(fieldData?.id).then(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
        this.ownerships.splice(index, 1);
      }).catch(() => {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
      });
    }
  }
}
